import axiosInstance from "./axiosInstance.ts";
import type { SolutionItem } from "./types.ts";

const PUBLIC_SOLUTIONS_ENDPOINT = "/v3/public/solutions";

const getSolutions = async () => {
  const response = await axiosInstance.get(PUBLIC_SOLUTIONS_ENDPOINT);
  const payload = response?.data;

  if (Array.isArray(payload)) {
    return payload as SolutionItem[];
  }

  if (Array.isArray(payload?.data)) {
    return payload.data as SolutionItem[];
  }

  if (Array.isArray(payload?.solutions)) {
    return payload.solutions as SolutionItem[];
  }

  if (Array.isArray(payload?.items)) {
    return payload.items as SolutionItem[];
  }

  return [];
};

export default getSolutions;
